<template>
  <notification-drop-down-list-item
    :title="title"
    icon="UploadCloudIcon"
    :color="color"
    @click-ntf="navigateToReport"
  >
    <small>
      {{ message }}
      <br>
      <strong>
        <a
          href="#"
          class="link-plain"
          @click.prevent.stop="navigateToReport">
          {{  $t('ViewAll') }}
        </a>
      </strong>
    </small>
  </notification-drop-down-list-item>
</template>

<script>
// Components
import NotificationDropDownListItem from '@/layouts/components/navbar/components/notifications/NotificationDropDownListItem.vue';

// Mixins
import notificationItemMixin from '@/layouts/components/navbar/components/notifications/mixins/notification-item.mixin';

export default {
  name: 'ImportProcessFinishedNotification',
  i18n: {
    messages: {
      en: {
        TitleSuccess: 'Import completed',
        TitleFailed: 'Import failed',
        TitleCanceled: 'Import canceled',
        MsgSuccess: 'Your {entity} import was completed.',
        MsgFailed: 'Your {entity} import could not be completed.',
        MsgCanceled: 'Your {entity} import was canceled.',
        ViewAll: 'View import report',
      },
    },
  },
  components: {
    NotificationDropDownListItem,
  },
  mixins: [notificationItemMixin],
  methods: {
    navigateToReport() {
      this.$router.push(this.to).catch((err) => {
        // Ignore NavigationDuplicated error
        const isNavigationDuplicated = err.name === 'NavigationDuplicated' ||
          (err.message && err.message.includes('Avoided redundant navigation'));

        if (!isNavigationDuplicated) {
          throw err;
        }
      });
    },
  },
  computed: {
    importId() {
      return this.payload && (this.payload.id || this.payload._id)
        ? this.payload.id || this.payload._id
        : '';
    },
    status() {
      return this.payload && this.payload.status
        ? this.payload.status
        : '';
    },
    entityName() {
      return this.payload && this.payload.entityName
        ? this.payload.entityName
        : '';
    },
    entityMapped() {
      return Object.values(this.$enums.Entity).find(
        (entity) => entity.toLowerCase() === this.entityName.toLowerCase()
          .replace(' ', '')
          .replace('-', ''),
      );
    },
    entityDisplay() {
      const name = this.$tc(`$Entities.${this.entityMapped}`, 2);
      return name ? name.toLowerCase() : '';
    },
    title() {
      switch (this.status) {
        case this.$enums.Import.STATUS.COMPLETED:
          return this.$t('TitleSuccess', { entity: this.entityDisplay });

        case this.$enums.Import.STATUS.FAILED:
          return this.$t('TitleFailed', { entity: this.entityDisplay });

        case this.$enums.Import.STATUS.CANCELED:
          return this.$t('TitleCanceled', { entity: this.entityDisplay });

        default:
          return '';
      }
    },
    message() {
      switch (this.status) {
        case this.$enums.Import.STATUS.COMPLETED:
          return this.$t('MsgSuccess', { entity: this.entityDisplay });

        case this.$enums.Import.STATUS.FAILED:
          return this.$t('MsgFailed', { entity: this.entityDisplay });

        case this.$enums.Import.STATUS.CANCELED:
          return this.$t('MsgCanceled', { entity: this.entityDisplay });

        default:
          return '';
      }
    },
    color() {
      return this.status === this.$enums.Import.STATUS.COMPLETED
        ? 'success'
        : 'danger';
    },
    to() {
      const queryParam = 'importReport';

      switch (this.entityMapped) {
        case this.$enums.Entity.TAG:
          return `/contacts/tags?${queryParam}=${this.importId}`;

        case this.$enums.Entity.CONTACT:
          return `/contacts/import?${queryParam}=${this.importId}`;

        case this.$enums.Entity.SMS_TEMPLATE:
          return `/sms/templates?${queryParam}=${this.importId}`;

        default:
          return '/';
      }
    },
  },
};
</script>

<style scoped>

</style>
